<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb :links="routesBread" />
        <TabNav :links="routesNav" />
    </div>

    <div class="container-body">
        <div class="info-grid">

            <section class="info-card">
                <h3 class="info-card__title">Información</h3>
                <dl class="info-card__list">
                    <div class="info-card__row">
                        <dt>Nombre</dt>
                        <dd>{{ doc.filename || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Descripción</dt>
                        <dd>{{ doc.description || '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Formato</dt>
                        <dd>{{ doc.path ? fileExtension(doc).toUpperCase() : '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <!-- dateFormatter no protege contra undefined (moment(undefined)
                             es "ahora"): sin este guard la fecha de hoy aparece hasta que
                             getDoc() resuelve. -->
                        <dt>Fecha creación</dt>
                        <dd>{{ doc.created_at ? dateFormatter(doc.created_at) : '—' }}</dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Visible en Ayuda</dt>
                        <dd>
                            <span class="badge" :class="doc.es_visible ? 'badge--on' : 'badge--off'">
                                {{ doc.es_visible ? 'Sí' : 'No' }}
                            </span>
                        </dd>
                    </div>
                    <div class="info-card__row">
                        <dt>Grupos asignados</dt>
                        <dd>{{ totalDocumentGroups }}</dd>
                    </div>
                </dl>

                <!-- Fuera del <dl>: dentro del dd el botón rompía la columna de
                     valores de la tarjeta al saltar de línea. -->
                <button
                    v-if="doc.id"
                    class="btn btn-secondary visibility-btn"
                    :disabled="toggling"
                    @click="onClickToggleVisibility()"
                >
                    {{ doc.es_visible
                        ? 'Ocultar en Mapa > Ayuda (grupos asignados)'
                        : 'Mostrar en Mapa > Ayuda (grupos asignados)' }}
                </button>
            </section>

            <section class="info-card">
                <h3 class="info-card__title">Archivo</h3>
                <DocumentPreview
                    v-if="doc.path"
                    :url="contentUrl(doc)"
                    :extension="fileExtension(doc)"
                    :name="doc.filename"
                    :size="doc.file_size"
                />
                <div v-else-if="doc.id" class="doc-preview__empty">
                    Este documento no tiene archivo asociado.
                </div>
            </section>

        </div>

        <div v-if="validationMessage" class="validation-summary">
            <div class="validation-summary__message">
                {{ validationMessage }}
            </div>
        </div>
    </div>

</main>
</template>

<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import DocumentPreview from '@/components/DocumentPreview.vue'

import { formatter } from '@/components/mixin/formatter.js'
import { restDocument } from '@/components/mixin/restDocument.js'

export default {
    name: 'DocumentsInfo',
    mixins: [formatter, restDocument],
    components: {
        Breadcrumb,
        TabNav,
        DocumentPreview
    },
    data () {
        return {
            toggling: false,
            validationMessage: ''
        }
    },
    computed: {
        routesNav: function () {
            return [
                {name: 'Resumen', path: '/documentos/' + this.$route.params.idDoc, exact: true},
                {name: 'Editar documento', path: '/documentos/' + this.$route.params.idDoc + '/editar-documento'},
                {name: 'Eliminar documento', path: '/documentos/' + this.$route.params.idDoc + '/eliminar-documento'}
            ]
        },
        routesBread: function () {
            return [
                {name: 'Documentos', path: '/documentos'},
                {name: this.doc.filename || '—'}
            ]
        },
        totalDocumentGroups: function () {
            return Array.isArray(this.doc.id_groups) ? this.doc.id_groups.length : 0
        }
    },
    methods: {
        onClickToggleVisibility: function () {
            this.toggling = true
            this.toggleDocVisibility(this.doc.id)
                .then(() => {
                    this.$store.dispatch('toast/show', {
                        message: this.doc.es_visible ? 'Documento ocultado' : 'Documento ahora visible',
                        type: 'info'
                    })
                    //getDoc() no retorna su promesa: se dispara y el flag se libera abajo
                    this.getDoc()
                })
                .catch(() => {
                    this.$store.dispatch('toast/show', {
                        message: 'No es posible cambiar la visibilidad del documento',
                        type: 'error'
                    })
                })
                .finally(() => {
                    this.toggling = false
                })
        }
    },
    created () {
        this.$store.getters.getPermissions?.documents ? true : this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.getDoc()
    }
}
</script>

<style lang="scss" scoped>
// Los estilos del sistema info-card/badge viven en assets/style/style.scss

.visibility-btn {
    margin-top: 0.75em;
    font-size: 0.85em;
}

.doc-preview__empty {
    margin: 0.75rem 0;
    font-size: 0.85rem;
    color: var(--color-ghost);
}

.validation-summary {
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid #dc3545;
    border-radius: 4px;
    background-color: #fff5f5;
}
.validation-summary__message {
    color: #dc3545;
    font-weight: 600;
}
</style>
